import { transformWebChatBotMessageDtoToModel } from "../WebChatBotMessage/utils";
import { WebChatBotConversationDto } from "./WebChatBotConversationDto";
import { WebChatBotConversationModel } from "./WebChatBotConversationModel";

export const transformWebChatBotConversationDtoToModel = (
  dto: WebChatBotConversationDto
): WebChatBotConversationModel => {
  return {
    ...dto,
    ...transformWebChatBotMessageDtoToModel(dto),
  };
};
